/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileJobItem } from './profileJobItem';

export interface ProfileJobsResponse {
  jobs: ProfileJobItem[];
  total: number;
  page: number;
  per_page: number;
}
